import * as UnitDivide from "../unit-divide";
import { CubicMeterPerSecond, CubicFeetPerMinute, LiterPerSecond, } from "./volume-flow";
import { SquareMeter, SquareFeet } from "./area";
// VolumeFlowPerArea
export var CubicMeterPerSecondPerSquareMeter = UnitDivide.volumeFlowByArea("CubicMeterPerSecondPerSquareMeter", CubicMeterPerSecond, SquareMeter);
export var CubicFeetPerMinutePerSquareFeet = UnitDivide.volumeFlowByArea("CubicFeetPerMinutePerSquareFeet", CubicFeetPerMinute, SquareFeet);
export var LiterPerSecondPerSquareMeter = UnitDivide.volumeFlowByArea("LiterPerSecondPerSquareMeter", LiterPerSecond, SquareMeter);
//# sourceMappingURL=volume-flow-per-area.js.map